(function () {
  const SESSION_KEY = 'babywagon_magic_checkout_started';
  const CART_CACHE_KEY = 'babywagon_magic_checkout_cached_cart';
  const DEBUG_QUERY = 'debug_magic_checkout=1';
  const CHECKOUT_SELECTORS = [
    '#checkout[name="checkout"][form="cart"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.cart__checkout-button',
  ];

  let hasPublishedThisPage = false;

  window.BABYWAGON_MAGIC_CHECKOUT_ANALYTICS_LOADED = true;

  function isDebugEnabled() {
    return window.location.search.indexOf(DEBUG_QUERY) !== -1;
  }

  function getSessionStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function getLocalStorage() {
    try {
      return window.localStorage;
    } catch (error) {
      return null;
    }
  }

  function setDebugMarker(key, value) {
    if (!isDebugEnabled()) return;

    const storage = getLocalStorage();
    if (!storage) return;

    storage.setItem(key, value);
  }

  function setDebugJson(key, value) {
    if (!isDebugEnabled()) return;

    const storage = getLocalStorage();
    if (!storage) return;

    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      storage.setItem(key, String(value));
    }
  }

  function hasSessionFlag() {
    const storage = getSessionStorage();
    if (!storage) return false;

    return storage.getItem(SESSION_KEY) === '1';
  }

  function setSessionFlag() {
    const storage = getSessionStorage();
    if (!storage) return;

    storage.setItem(SESSION_KEY, '1');
  }

  function getCheckoutTarget(element) {
    if (!element || typeof element.closest !== 'function') return null;

    for (let index = 0; index < CHECKOUT_SELECTORS.length; index += 1) {
      const selector = CHECKOUT_SELECTORS[index];
      const match = element.closest(selector);

      if (match) {
        return {
          element: match,
          selector,
        };
      }
    }

    return null;
  }

  function describeTarget(target) {
    if (!target) return 'unknown';

    const parts = [];
    const element = target.element;

    parts.push(target.selector);

    if (element.id) parts.push('#' + element.id);
    if (element.name) parts.push('[name="' + element.name + '"]');
    if (element.form && element.form.id) parts.push('[form="' + element.form.id + '"]');

    return parts.join(' ');
  }

  function isCartContext() {
    return Boolean(
      document.querySelector('#cart') ||
        document.querySelector('#main-cart-footer') ||
        document.querySelector('#CartDrawer') ||
        document.querySelector('cart-drawer')
    );
  }

  function buildCachedCartPayload(cart) {
    return {
      source: 'razorpay_magic_checkout',
      currency: cart.currency || 'INR',
      value: typeof cart.total_price === 'number' ? cart.total_price / 100 : null,
      cart_token: cart.token || cart.cart_token || null,
      items: Array.isArray(cart.items)
        ? cart.items.map((item) => ({
            variant_id: item.variant_id || item.id || null,
            product_title: item.product_title || item.title || '',
            variant_title: item.variant_title || '',
            quantity: item.quantity || 0,
            price: typeof item.price === 'number' ? item.price / 100 : 0,
          }))
        : [],
    };
  }

  function cacheCartPayload(payload) {
    const storage = getSessionStorage();
    if (!storage) return;

    storage.setItem(CART_CACHE_KEY, JSON.stringify(payload));
    setDebugMarker('bw_magic_checkout_cached_cart_ready', '1');
  }

  function getCachedCartPayload() {
    const storage = getSessionStorage();
    if (!storage) return null;

    const rawPayload = storage.getItem(CART_CACHE_KEY);
    if (!rawPayload) return null;

    try {
      return JSON.parse(rawPayload);
    } catch (error) {
      return null;
    }
  }

  async function prefetchCartPayload() {
    if (!isCartContext()) return;

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        return;
      }

      const cart = await response.json();
      cacheCartPayload(buildCachedCartPayload(cart));
    } catch (error) {
      // Intentionally silent: checkout must remain unaffected.
    }
  }

  function buildPublishPayload() {
    const cachedPayload = getCachedCartPayload();

    if (cachedPayload) {
      return Object.assign({}, cachedPayload, {
        event_id: 'magic_checkout_started_' + Date.now(),
      });
    }

    return {
      source: 'razorpay_magic_checkout',
      currency: 'INR',
      value: null,
      items: [],
      fallback_reason: 'missing_cached_cart',
      event_id: 'magic_checkout_started_' + Date.now(),
    };
  }

  function publishMagicCheckoutStarted(triggerName, target) {
    if (hasPublishedThisPage || hasSessionFlag()) {
      return;
    }

    setDebugMarker('bw_magic_checkout_click_seen', triggerName);
    setDebugMarker('bw_magic_checkout_target', describeTarget(target));

    const publishApi =
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
        ? window.Shopify.analytics.publish.bind(window.Shopify.analytics)
        : null;

    const payload = buildPublishPayload();

    setDebugMarker('bw_magic_checkout_publish_attempted', String(Date.now()));
    setDebugJson('bw_magic_checkout_debug_payload', payload);

    try {
      if (publishApi) {
        publishApi('magic_checkout_started', payload);
      }

      hasPublishedThisPage = true;
      setSessionFlag();
      setDebugMarker('bw_magic_checkout_publish_completed', String(Date.now()));
    } catch (error) {
      // Intentionally silent: checkout must remain unaffected.
    }
  }

  function handlePointerLikeEvent(event) {
    const target = getCheckoutTarget(event.target);
    if (!target) return;

    publishMagicCheckoutStarted(event.type, target);
  }

  function handleSubmitEvent(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitter = event.submitter || document.activeElement;
    const target = getCheckoutTarget(submitter);
    if (!target) return;

    publishMagicCheckoutStarted(event.type, target);
  }

  setDebugMarker('bw_magic_checkout_listener_loaded', '1');

  document.addEventListener('pointerdown', handlePointerLikeEvent, true);
  document.addEventListener('mousedown', handlePointerLikeEvent, true);
  document.addEventListener('click', handlePointerLikeEvent, true);
  document.addEventListener('submit', handleSubmitEvent, true);

  prefetchCartPayload();
})();
